import { Pipe, PipeTransform } from '@angular/core';
import { getISODay } from 'date-fns';

const days = {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday',
}

@Pipe({
    name: 'weekdayName',
    standalone: true
})
export class WeekdayNamePipe implements PipeTransform {

    transform(date: Date): string {
        return days[getISODay(date)];
    }
}
